import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  resaleArticles: null,

  article: {
    id: null,
    title_ru: '',
    title_en: '',
    description_ru: '',
    description_en: '',
  },
};

export const partnersSlice = createSlice({
  name: 'partners',
  initialState,
  reducers: {
    setResaleArticles: (state, action) => {
      state.resaleArticles = action.payload;
    },

    setPartnerArticle: (state, action) => {
      state.article = action.payload;
    },

    resetPartners: () => initialState,
  },
});

export const {
  setResaleArticles,

  setPartnerArticle,

  resetPartners,
} = partnersSlice.actions;

export default partnersSlice.reducer;
